<template>
  <section class="step-section">
    <div class="container">
      <slot name="header">
        <header class="step-section__header" v-if="title || description">
          <h1
            class="heading show-content-js"
            v-if="title"
            @click="toggleDescription"
          >
            <b v-if="stepNumber">{{ $t('step') }} {{ stepNumber }}</b>
            <span v-html="title"></span>
          </h1>
          <collapse-transition>
            <p v-if="description && descriptionVisible">
              {{ description }}
            </p>
          </collapse-transition>
        </header>
      </slot>
      <div class="step-section__content" v-if="!loading">
        <slot />
      </div>
      <div class="step-section__loading" v-else>
        <v-loader />
      </div>
    </div>
  </section>
</template>

<script>
  import { CollapseTransition } from 'vue2-transitions';

  export default {
    name: 'StepSection',
    props: {
      title: String,
      description: String,
      loading: Boolean,
      stepNumber: [String, Number],
    },
    data() {
      return {
        descriptionVisible: true,
      };
    },
    methods: {
      toggleDescription() {
        this.descriptionVisible = !this.descriptionVisible;
      },
    },
    components: {
      CollapseTransition,
    },
  };
</script>
